import { render } from "./API.vue?vue&type=template&id=0ecc54ac"
import script from "./API.vue?vue&type=script&lang=js"
export * from "./API.vue?vue&type=script&lang=js"

import "./API.vue?vue&type=style&index=0&id=0ecc54ac&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.26.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__